import axios from 'axios'

var http = axios.create({
  baseURL: process.env.API_BASE_URL + '/file',
  headers: {'Content-Type': 'multipart/form-data'}
})

http.interceptors.response.use(function (response) {
  return response
}, function (error) {
  return {data: 'error'}
  // if (error.response.status && error.response.status !== 401) return Promise.reject(error)
  // var refreshAndRetry = new Promise(function (resolve) {
  //   axios.post(process.env.API_BASE_URL + '/account/refresh_token',
  //     {
  //       'refresh_token': JSON.parse(localStorage.getItem('refresh_token')).value
  //     },
  //     {
  //       headers: {
  //         'Content-Type': 'application/json',
  //         'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
  //       }
  //     }).then(function (response) {
  //     localStorage.setItem('refresh_token', JSON.stringify({
  //       value: response.data.refresh_token,
  //       expire: null
  //     }))

  //     localStorage.setItem('token', JSON.stringify({
  //       value: response.data.token,
  //       expire: null
  //     }))

  //     return Promise.resolve(response)
  //   }).then(function (response) {
  //     var failedRequest = error.config
  //     failedRequest.headers.Authorization = 'Bearer ' + JSON.parse(localStorage.getItem('token')).value
  //     axios.request(failedRequest).then(function (retryResponse) {
  //       resolve(retryResponse)
  //     })
  //   })
  // })

  // return refreshAndRetry
})

var http2 = axios.create({
  baseURL: process.env.API_BASE_URL + '/file',
  responseType: 'arraybuffer',
  headers: {'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',accept:
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}
})


function getConfig () {
  return {
    headers: {
      'Authorization': JSON.parse(localStorage.getItem('token')).value
    }
  }
}

function upload(file, path, callback) {
    var config = getConfig()
    config.headers['Content-Type'] = 'multipart/form-data'

    var url = '/upload'
    var formData = new FormData()
    formData.append('file', file)
    formData.append('key_name', path)

    http.post(url, formData, config).then(function(response) {
      if(response.data === 'error'){
        callback({
          success: false,
          data: response.data
        })
      } else {
        callback({
          success: true,
          data: response.data
        })
      }
      
    })
}

function adminBundleUpload(file, path, callback) {
  var config = getConfig()
  config.headers['Content-Type'] = 'multipart/form-data'

  var url = '/admin_upload_bundle'
  var formData = new FormData()
  formData.append('file', file)
  formData.append('key_name', path)

  http.post(url, formData, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    }).catch(function(error) {
      callback({
        success: false,
        data: error.response.data.message
      })
    })
  })
}

function download(path, callback) {
  var config = getConfig()
  var url = '/download?key_name=' + path

  http.get(url, config).then(function(response) {
    callback({
      success: true,
      data: response.data
    })
  }).catch(function(error) {
    callback({
      success: false,
      message: error.response.data.message
    })
  })
}

function download2(path, callback) {
  var config = getConfig()
  var url = '/download?key_name=' + path

  http2.get(url, config).then(function(response) {
    const url = URL.createObjectURL(
      new Blob([response.data], {
        type: 'application/vnd.ms-excel',
      })
    )
    const link = document.createElement('a')
    link.href = url
    let fileName = path.split('/')
    link.setAttribute('download', fileName[1])
    document.body.appendChild(link)
    link.click()
    this.notify('success', 'File Hasil Rasionalisasi berhasil diunduh')
  }).catch(function(error) {
    callback({
      success: false,
      message: error.response.data.message
    })
  })
}
export default {upload, download, download2, adminBundleUpload}



// WEBPACK FOOTER //
// ./src/services/file.js